export const umbracoUrls = {
    local: "",
    localDev: "https://localhost:44377",
    devTest: "https://unificationdev.azurewebsites.net",
    proxy: "http://localhost:5203/umbraco-site"
}

const devTestSelfService = "https://unificationdev.azurewebsites.net/{culture}/mydstv";

export const utilityServiceUrls = {
    devTest: "https://wakanda-api.azurewebsites.net",
    local: "http://localhost:5000"
}

export const utilityServiceUrl = utilityServiceUrls.devTest;

export const localEnvironment = {
    useSampleData: false,
    defaultLanguage: "en",
    defaultCulture: "en-za",
    disableAnalytics: false,
    urls: {
        menuConfig: umbracoUrls.local,
        assets: "/content/menu-v2/",
        imagePrefix: "",
        selfService: ""
    },
    mainLogo: {
        title: "DStv",
        image: "logos/dstv.svg",
        logoHeight: "16px",
        logoMobileHeight: "16px"
    },
    appBanner: {
        appLogo : "https://unificationdev.azurewebsites.net/media/1typofji/mydstv-app-logo.jpg",
        oneLink: "https://mydstv-thiane.onelink.me/ivCe/1feilxgo"
    }
};

export const getDevEnvironment = (useSampleData = false, useProxy = false) => {
    const imagePrefix = useSampleData ? "" : umbracoUrls.devTest
    const menuConfig = useProxy ? umbracoUrls.proxy : umbracoUrls.devTest;

    return {
        useSampleData: useSampleData,
        defaultLanguage: "en",
        defaultCulture: "en-za",
        disableAnalytics: false,
        urls: {
            menuConfig: menuConfig,
            assets: "/",
            imagePrefix: imagePrefix,
            selfService: devTestSelfService,
        },
        mainLogo: {
            title: "DStv",
            image: "logos/dstv.svg",
            logoHeight: "24px",
            logoMobileHeight: "24px"
        },
        appBanner: {
            appLogo: "https://unificationdev.azurewebsites.net/media/1typofji/mydstv-app-logo.jpg",
            oneLink: "https://mydstv-thiane.onelink.me/ivCe/1feilxgo",
        }
    };
}

export const devEnvironment = getDevEnvironment();
